import { Word } from './word';

export interface FindResult {
  obj: Word;
  ax: number;
  ay: number;
}

export const LevelDefaults = {
  DefaultWidth: 12,
  DefaultHeight: 9,
  MinLevelSize: 3,
  MaxLevelSize: 12,
  MinKeywordLength: 3,
  MaxKeywordLength: 8,
  MinWordsCount: 2,
  MaxWordsCount: 10,
  MinWordSize: 3,
  MaxWordSize: 7,
};

export class Level {
  id: number;
  lang: string;
  keyword: string = '';
  difficulty: number = 0;
  width: number;
  height: number;
  words: Word[];
  number: number;

  constructor(
    lang: string,
    words: Word[] = [],
    id: number = 0,
    w: number = LevelDefaults.DefaultWidth,
    h: number = LevelDefaults.DefaultHeight,
    number: number = 0
  ) {
    this.id = id;
    this.lang = lang;
    this.width = w;
    this.height = h;
    this.words = [...words];
    this.number = number;
  }
}
